<template>
    <van-tabbar
            :border="false"
            v-model="_active"
            safe-area-inset-bottom
            class="tabbar"
            active-color="#FBB439"
    >
        <van-tabbar-item icon="setting-o" to="/">
            <img slot="icon" :src="_active ==='index' ? home_active:home"/>
            <p>首页</p>
        </van-tabbar-item>
        <van-tabbar-item name="team" to="/team">
            <img slot="icon" :src="_active ==='team' ? team_active:team"/>
            <p>团队</p>
        </van-tabbar-item>
        <van-tabbar-item name="trade" to="/tradeCenter">
            <img slot="icon" :src="_active ==='trade' ? trade_active: trade"/>
            <p>交易</p>
        </van-tabbar-item>
        <van-tabbar-item name="c2c" to="/c2cIndex">
            <img slot="icon" :src="_active ==='c2c' ? c2c_active: c2c"/>
            <p>C2C交易</p>
        </van-tabbar-item>
        <van-tabbar-item name="user" to="/user">
            <img slot="icon" :src="_active ==='user' ? user_active:user"/>
            <p>个人</p>
        </van-tabbar-item>
    </van-tabbar>
</template>

<script>
    import home_active from "../assets/img/tabbar/home_active.png";
    import home from "../assets/img/tabbar/home.png";
    import team_active from "../assets/img/tabbar/team_active.png";
    import team from "../assets/img/tabbar/team.png";
    import user_active from "../assets/img/tabbar/user_active.png";
    import user from "../assets/img/tabbar/user.png";
    import trade_active from "../assets/img/tabbar/trade_active.png";
    import trade from "../assets/img/tabbar/trade.png";
    import c2c_active from "../assets/img/tabbar/c2c_active.png";
    import c2c from "../assets/img/tabbar/c2c.png";

    export default {
        props: ["active"],
        data() {
            return {
                home_active,
                home,
                team_active,
                team,
                user_active,
                user,
                trade_active,
                trade,
                c2c_active,
                c2c
                //active:''
            };
        },
        created() {
            console.log(this.active);
            this._active = this.active;
        },
        methods: {
            // change(){
            //   this.$route.push('/'+ active)
            // }
        }
    };
</script>

<style lang="scss" scoped>
    .tabbar {
        height: 98px;
        background-color: #fff;

        img {
            height: 30px;
        }

        p {
            font-size: 20px;

            font-weight: 500;
            color: rgba(193, 193, 193, 1);
            line-height: 30px;
        }

        .van-tabbar-item {
            justify-content: flex-start;
            padding-top: 15px;
        }
    }
</style>
